import { FC, useEffect } from "react";
import AppList from "@lhd/components/CloneApp/pages/AppList";
import SearchAreaBox from "@lhd/components/SearchAreaBox";
import useList from "./hook";
import { Styles } from "./styled";
import { ROUTES } from "@lhd/constants";
import { useNavigate } from "react-router-dom";
import { useGetAuth, useSalaryPermission } from "@lhd/hooks";

const optionDefaultStatus = [
  { value: "drafting", text: "新規作成中" },
  { value: "submitted", text: "新規申請済（承認待）" },
  { value: "reviewing", text: "申請受付済（確認中）" },
  { value: "approved", text: "承認済（給与明細反映）" },
  { value: "rejected", text: "却下" },
];

const ListLayout = (props: ReturnType<typeof useList>) => {
  const { auth, isAdmin, isSuperAdmin, isSupperAdminLoggingIn } = useGetAuth();
  const salaryConfigs = useSalaryPermission(!!auth);
  const navigate = useNavigate();

  const {
    statusFilterSelected,
    setStatusFilterSelected,
    categoryFilterSelected,
    setCategoryFilterSelected,
    handleChangeStatus,
    handleChangeCategory,
    closeSignal,
    isOwner,
  } = props;

  useEffect(() => {
    if (!auth?.can_approve_business_trip_report && !isOwner) {
      navigate(`/${ROUTES.NOT_FOUND_PAGE}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.can_approve_business_trip_report, isOwner]);

  // Enable edit/add button for super admin, admin, and users with salary delete permission
  const hasSalaryDeletePermission = Boolean(
    salaryConfigs?.data?.salary_delete?.length,
  );

  const canEditCategory =
    isAdmin ||
    isSuperAdmin ||
    isSupperAdminLoggingIn ||
    hasSalaryDeletePermission;

  return (
    <Styles>
      <SearchAreaBox
        tableName="business_trip_reports"
        screen="business_trip_reports"
        nonEditable
        fieldStatus="business_trip_report_info.status"
        fieldCategory="business_trip_report_info.category"
        statusFilterSelected={statusFilterSelected}
        handleChangeStatus={handleChangeStatus}
        categoryFilterSelected={categoryFilterSelected}
        handleChangeCategory={handleChangeCategory}
        textStatusField="ステータス"
        textCategoryField="カテゴリー"
        optionDefaultStatus={optionDefaultStatus}
        setStatusFilterSelected={setStatusFilterSelected}
        setCategoryFilterSelected={setCategoryFilterSelected}
        disabledButtonEdit={!canEditCategory}
      />
      <AppList
        quickButtonDirection="vertical"
        {...props}
        forceCloseQuickViewSignal={closeSignal}
      />
    </Styles>
  );
};

const List: FC = () => <ListLayout {...useList()} />;

export default List;
